<template>
    <div class="home-index" :class="{ 'top-bar-dis': isTitleBarFixed }">
        <!-- 顶部描述 -->
        <div class="charm-message-cont section-message-cont">
            <n-carousel autoplay :interval="3000" :show-dots="true">
                <div
                    v-for="(item, idx) in curBannerList"
                    :key="item.id"
                    class="img-cont"
                >
                    <!-- <img :src="item.imgSrc" alt="bannner" /> -->
                    <!-- <div class="banner-bg" :style="`background-image: url(${item.imgSrc});`"></div> -->
                    <div
                        class="musk-banner-bg"
                        :style="`background: linear-gradient(90deg, #000 0%, #000 12%, rgba(0, 0, 0, 0.00) 80%), url(${item.imgSrc}) lightgray center 20% / cover no-repeat ;`"
                    ></div>
                </div>
            </n-carousel>

            <div class="slogon-cont">
                <div class="slogon-title">Live Fully-Not Just Exist</div>
                <div class="slogon-text">
                    We proudly donate 100% of profits from doctor bookings and
                    subscriptions to charity—turning your pursuit of Charm-Vibe
                    into real-world impact.
                </div>
            </div>

            <div class="loading-bar-cont">
                <div class="loading-bar"></div>
            </div>

            <div class="message-cont">
                <div class="message-title text-gradient">
                    Guided by Expertise. Driven by Purpose. Focused on You
                </div>
            </div>

            <div class="btn-cont">
                <n-button
                    class="gradient-btn"
                    color="#000000"
                    @click="_handleShowCharmVideo"
                >
                    What is Charm?
                </n-button>
                <n-button
                    class="default-btn"
                    color="#ffffff"
                    text-color="#000000"
                    @click="_goToDoctorsHomePage"
                >
                    Consult a doctor
                </n-button>
            </div>
        </div>

        <!-- 医生描述 -->
        <div class="doctor-message-cont section-message-cont">
            <div class="img-cont">
                <div class="img-item">
                    <div class="img-item-bg">
                        <img
                            src="@/assets/images/home/home_doctor_image_001.png"
                        />
                    </div>
                    <div class="img-item-message">
                        <span>Embrace flawless skin</span>
                    </div>
                </div>
                <div class="img-item">
                    <div class="img-item-bg">
                        <img
                            src="@/assets/images/home/home_doctor_image_002.png"
                        />
                    </div>
                    <div class="img-item-message">
                        <span>Luminous complexion</span>
                    </div>
                </div>
                <div class="img-item">
                    <div class="img-item-bg">
                        <img
                            src="@/assets/images/home/home_doctor_image_003_new.png"
                        />
                    </div>
                    <div class="img-item-message">
                        <span>Visibly reduced signs of ageing</span>
                    </div>
                </div>
            </div>

            <div class="message-cont">
                <div class="message-title text-gradient">
                    Exclusivity. Expertise. Elegance
                </div>
                <div class="message-describe">
                    Where luxury meets trust—Charm-Vibe is your gateway to
                    verified experts,and your lifestyle of beauty and confidence
                    begins.
                </div>
            </div>
        </div>

        <!-- 帖子描述 -->
        <div class="post-message-cont section-message-cont">
            <div class="img-cont">
                <div class="img-cont-bg">
                    <img src="@/assets/images/home/home_doctor_image_004.png" />
                </div>
            </div>

            <div class="message-cont">
                <div class="message-title text-gradient">
                    Charm-Vibe charity: Restoring Smiles, Rebuilding Futures
                </div>
                <div class="message-describe">
                    Luxury With Heart. Medicine With Meaning. <br />Funding
                    their smiles.
                </div>
            </div>
        </div>

        <!-- 其他手术项目 -->
        <div class="other-cosmetic-procedures section-message-cont">
            <div class="message-cont">
                <div class="message-title text-gradient">
                    Other Cosmetic Procedures
                </div>
            </div>

            <div class="cosmetic-procedures-cont">
                <div
                    v-for="(item, index) in otherCosmeticProceduresList"
                    :key="index"
                    class="cosmetic-procedures-item"
                    @click="_goToProcedureDetailPage(item.categoryName)"
                >
                    <img :src="item.imgSrc" />
                    <div>{{ item.name }}</div>
                </div>
            </div>

            <div class="btn-cont">
                <n-button
                    class="gradient-btn"
                    color="#000000"
                    @click="_goToProcedureHomePage"
                >
                    View All Procedures
                </n-button>
            </div>
        </div>

        <!-- 下载信息 -->
        <div class="download-message-cont section-message-cont">
            <div class="phone-cont" @click="_handleShowCharmH5Video">
                <div class="logo-box">
                    <n-icon class="btn-icon" size="120">
                        <img src="@/assets/images/layout/APP_LOGO.svg" />
                    </n-icon>
                    <div class="text">Charm</div>
                </div>
            </div>

            <div class="qrcode-cont">
                <img src="@/assets/images/home/download_scan_qrcode_img.png" />
                <div class="tip">Scan to view the mobile</div>
            </div>
        </div>

        <!--preview video-->
        <VideoPreviewModal
            v-if="showVideoPreviewModal"
            v-model:show="showVideoPreviewModal"
            :options="curVideoPreivewOpts"
            to=".home-index"
        ></VideoPreviewModal>
    </div>
</template>

<script lang="ts" setup>
import { NButton, NCarousel, NIcon } from "naive-ui";
import { computed, nextTick, onMounted, onUnmounted, ref } from "vue";
import { ProcedureTransMockList } from "@/mock/MockList";
import VideoPreviewModal from "@/components/VideoPreviewModal.vue";
import { useRouter } from "vue-router";
import videoUrl from "@/assets/images/home/App-Demo-V10.mp4";
import videoH5Url from "@/assets/images/home/App-Demo-H5.mp4";
import { BannersList } from "@/constant";
import { getRandomElements } from "@/utils/util";

const router = useRouter();
const otherCosmeticProceduresList = ref<any>(ProcedureTransMockList);
const screenMinWidth = ref<number>(1440);
const calcDoctorImgContWidth = ref<number>(480);
const showVideoPreviewModal = ref<boolean>(false);
const videoPreviewOpts = {
    showEdit: false,
    src: videoUrl,
};
const videoH5PreviewOpts = {
    showEdit: false,
    src: videoH5Url,
};
const curVideoPreivewOpts = ref(videoPreviewOpts);

const calcDoctorImgContHeightObj = computed(() => {
    return {
        height: (calcDoctorImgContWidth.value * 600) / 480 + "px",
    };
});
const curBannerList = computed(() => {
    const list = getRandomElements(BannersList, 3);
    return list;
});

const isTitleBarFixed = ref<boolean>(true);

// 计算屏幕大小
const calcScreenMinWidth = (vWidth: number) => {
    if (vWidth >= 1440) {
        screenMinWidth.value = 1440;
    }
    if (1020 <= vWidth && vWidth < 1440) {
        screenMinWidth.value = 1020;
    }
    if (vWidth < 1020) {
        screenMinWidth.value = 744;
    }
};

const _onShowVideoPreviewModal = () => {
    showVideoPreviewModal.value = !showVideoPreviewModal.value;
};

const _handleShowCharmVideo = () => {
    curVideoPreivewOpts.value = videoPreviewOpts;
    nextTick(() => {
        _onShowVideoPreviewModal();
    });
};

const _handleShowCharmH5Video = () => {
    curVideoPreivewOpts.value = videoH5PreviewOpts;
    nextTick(() => {
        _onShowVideoPreviewModal();
    });
};

const _goToDoctorsHomePage = () => {
    router.push({
        path: "/doctor",
    });
};

const _goToPostHomePage = () => {
    router.push({
        path: "/post",
    });
};

const _goToProcedureDetailPage = (categoryName: string) => {
    router.push({
        path: "/procedure/procedureDetail",
        query: {
            categoryName,
        },
    });
};

const _goToProcedureHomePage = () => {
    router.push({
        path: "/procedure",
    });
};

onMounted(() => {
    calcScreenMinWidth(window.innerWidth);
    calcDoctorImgContWidth.value = (window.innerWidth - 2 * 80) / 3;
    window.addEventListener("resize", () => {
        calcScreenMinWidth(window.innerWidth);
        calcDoctorImgContWidth.value = (window.innerWidth - 2 * 80) / 3;
    });
});

onUnmounted(() => {
    window.removeEventListener("resize", () => {
        calcScreenMinWidth(window.innerWidth);
    });
});
</script>

<style lang="scss" scoped>
.home-index {
    background-color: #f0f7ff;

    .section-message-cont {
        .message-cont {
            .message-title {
                margin: 0 auto;
                width: 80%;
                text-align: center;
                font-size: 36px;
                font-family: "San Francisco Text";
                font-style: normal;
                font-weight: 500;
                line-height: 180%; /* 64.8px */
            }

            .message-describe {
                margin: 24px auto 0;
                width: 80%;
                color: rgba(0, 0, 0, 0.8);
                text-align: center;
                font-size: 18px;
                font-family: "San Francisco Text";
                font-style: normal;
                font-weight: 400;
                line-height: 180%; /* 32.4px */
            }
        }
        .btn-cont {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 24px;

            :deep(.n-button) {
                width: 280px;
                height: 72px;
                border-radius: 40px;
                border: 1px solid #000000;
                font-size: 24px;
                font-weight: 400;
                box-shadow: 0px 4px 10px 0px rgba(23, 51, 72, 0.2);
            }

            :deep(.n-button.gradient-btn .n-button__content) {
                background: linear-gradient(93deg, #8ef 0%, #ff7de7 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }
    }
    .charm-message-cont {
        position: relative;
        // padding-top: 14px;

        .img-cont {
            position: relative;
            width: 100%;
            height: 590px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .banner-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 590px;
            background-color: #ffffff;
            background: linear-gradient(
                    180deg,
                    rgba(23, 51, 72, 0) 35.89%,
                    rgba(23, 51, 72, 0.5) 69.74%
                ),
                lightgray 50% / cover no-repeat;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center 20%;
            z-index: 1;
        }

        .musk-banner-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 590px;
            background-color: #ffffff;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center 20%;
            z-index: 2;
        }

        .slogon-cont {
            position: absolute;
            top: 0;
            left: 120px;
            width: 60%;
            margin: 0 80px;
            max-width: 560px;
            transform: translate(0, 120px);

            .slogon-title {
                color: #fff;
                font-family: "San Francisco Text";
                font-size: 70px;
                font-style: normal;
                font-weight: 600;
                line-height: 70px; /* 100% */
                text-transform: uppercase;
            }
            .slogon-text {
                margin-top: 32px;
                color: #fff;
                font-family: "San Francisco Text";
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 27px */
            }
        }

        .loading-bar-cont {
            width: 100%;
            height: 2px;
            background-color: transparent;

            .loading-bar {
                width: 0;
                height: 2px;
                background: linear-gradient(93deg, #8ef 0%, #ff7de7 100%);
                animation: loading-bar-animation 3s ease-in-out infinite;
            }
        }

        @keyframes loading-bar-animation {
            0% {
                width: 0;
            }
            100% {
                width: 100%;
            }
        }

        .message-cont {
            margin-top: 100px;
        }

        .btn-cont {
            margin-top: 40px;
        }
    }

    .doctor-message-cont {
        margin-top: 100px;

        .img-cont {
            display: flex;
            width: calc(100% - 2 * 80px);
            margin: 0 80px;
            flex-direction: row;
            gap: 28px;

            .img-item {
                position: relative;
                width: 100%;
                height: auto;
                background-size: cover;
                border-radius: 28px;
                overflow: hidden;

                .img-item-bg {
                    width: 100%;

                    img {
                        width: 100%;
                        height: auto;
                        object-fit: fill;
                    }
                }

                .img-item-message {
                    display: flex;
                    position: absolute;
                    left: 0;
                    bottom: 35px;
                    width: 100%;
                    align-items: center;
                    justify-content: center;
                    z-index: 1;

                    span {
                        color: #fff;
                        text-align: center;
                        font-family: "San Francisco Text";
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                    }
                }
            }
        }

        .message-cont {
            margin-top: 60px;
        }
    }

    .post-message-cont {
        margin-top: 100px;

        .img-cont {
            display: flex;
            width: calc(100% - 2 * 80px);
            margin: 0 80px;
            align-items: center;
            justify-content: center;

            .img-cont-bg {
                width: 100%;
                border-radius: 28px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: auto;
                    object-fit: fill;
                }
            }
        }

        .message-cont {
            margin-top: 60px;
        }
    }

    .other-cosmetic-procedures {
        margin-top: 100px;
        padding-top: 50px;
        padding-bottom: 100px;
        background-color: #131313;

        .cosmetic-procedures-cont {
            margin-top: 40px;
            padding: 0 80px;
            display: flex;
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            box-sizing: border-box;

            .cosmetic-procedures-item {
                cursor: pointer;
                margin-top: 20px;
                width: 25%;
                height: 200px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &:hover {
                    img {
                        opacity: 1;
                    }

                    div {
                        font-weight: 800;
                        color: rgba(255, 255, 255, 1);
                    }
                }

                img {
                    width: 140px;
                    height: 140px;
                    opacity: 0.8;
                }

                div {
                    color: rgba(255, 255, 255, 0.8);
                    text-align: center;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }
        }

        .btn-cont {
            margin-top: 60px;

            :deep(.n-button) {
                height: 60px;
                padding: 0 28px;
                border-radius: 30px;
                border: 2px solid transparent;
                font-size: 18px;
                font-weight: 500;
                box-shadow: none;
                background-image: url("@/assets/icons/icon_btn_gradient.svg");
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }

            :deep(.n-button.gradient-btn .n-button__content) {
                background: linear-gradient(93deg, #8ef 0%, #ff7de7 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }
    }

    .download-message-cont {
        padding-top: 100px;
        padding-bottom: 100px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background-color: #fff;

        .phone-cont {
            position: relative;
            width: 300px;
            height: 557px;
            background-image: url("@/assets/images/home/download_phone_img.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;

            .logo-box {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                .btn-icon {
                    width: 120px;
                    height: 120px;
                    margin-left: 0;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .text {
                    color: #000;
                    text-align: center;
                    font-family: "Oleo Script Swash Caps Regular";
                    font-size: 32px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }
        }

        .qrcode-cont {
            margin-left: 50px;

            img {
                margin-top: 11px;
                width: 235px;
                height: 235px;
            }

            .tip {
                margin-top: 10px;
                padding-left: 9px;
                color: #363636;
                font-family: "Abhaya Libre Regular";
                font-size: 22px;
                font-style: normal;
                font-weight: 400;
                line-height: 135%;
            }
        }
    }
}

@media screen and (max-width: 1024px) and (min-width: 744px) {
    .home-index {
        .section-message-cont {
            .message-cont {
                .message-title {
                    font-size: 30px;
                }

                .message-describe {
                    font-size: 18px;
                }
            }
            .btn-cont {
                gap: 20px;

                :deep(.n-button) {
                    font-size: 18px;
                }
            }
        }
        .charm-message-cont {
            .img-cont {
                height: 460px;
            }

            .banner-bg {
                height: 460px;
                background-position: center 20%;
            }

            .musk-banner-bg {
                height: 460px;
                background-position: center 20%;
            }

            .slogon-cont {
                position: absolute;
                top: 0;
                left: 40px;
                width: 50%;
                margin: 0 40px;
                max-width: 450px;
                transform: translate(0, 150px);

                .slogon-title {
                    font-size: 35px;
                    line-height: 40px;
                }
                .slogon-text {
                    margin-top: 30px;
                    padding: 0 30px 0 0;
                    font-size: 18px;
                }
            }
        }
        .doctor-message-cont {
            .img-cont {
                width: calc(100% - 2 * 40px);
                margin: 0 40px;
            }
        }

        .post-message-cont {
            .img-cont {
                width: calc(100% - 2 * 40px);
                margin: 0 40px;
            }
        }
        .other-cosmetic-procedures {
            .cosmetic-procedures-cont {
                padding: 0 40px;
            }
        }
    }
}

@media screen and (max-width: 744px) {
    .home-index {
        .section-message-cont {
            .message-cont {
                .message-title {
                    margin: 0 auto;
                    width: 90%;
                    font-size: 20px;
                }

                .message-describe {
                    margin: 20px auto 0;
                    width: 90%;
                    font-size: 14px;
                }
            }
            .btn-cont {
                gap: 12px;

                :deep(.n-button) {
                    width: 160px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 14px;
                }
            }
        }
        .charm-message-cont {
            .img-cont {
                height: 300px;
            }

            .banner-bg {
                height: 300px;
                background-position: center 20%;
            }

            .musk-banner-bg {
                height: 300px;
                background-position: center 20%;
            }

            .slogon-cont {
                position: absolute;
                top: 160px;
                left: 50%;
                width: 100%;
                max-width: calc(100% - 12px);
                margin: 0 12px 0 0;
                transform: translate(-50%, 0);

                .slogon-title {
                    font-size: 20px;
                    text-align: center;
                    line-height: 20px;
                }
                .slogon-text {
                    margin-top: 12px;
                    padding: 0 10px;
                    font-size: 12px;
                    text-align: center;
                }
            }

            .message-cont {
                margin-top: 100px;
            }

            .btn-cont {
                margin-top: 40px;
            }
        }

        .doctor-message-cont {
            margin-top: 60px;

            .img-cont {
                display: flex;
                width: calc(100% - 2 * 20px);
                margin: 0 20px;
                gap: 14px;

                .img-item {
                    min-height: 143px;
                    border-radius: 14px;

                    .img-item-message {
                        bottom: 16px;

                        span {
                            font-size: 12px;
                        }
                    }
                }
            }

            .message-cont {
                margin-top: 20px;
            }
        }

        .post-message-cont {
            margin-top: 60px;

            .img-cont {
                width: calc(100% - 2 * 20px);
                margin: 0 20px;

                .img-cont-bg {
                    border-radius: 14px;
                }
            }

            .message-cont {
                margin-top: 20px;
            }
        }
        .other-cosmetic-procedures {
            margin-top: 60px;
            padding-bottom: 60px;
            .message-cont {
                .message-title {
                    width: 100%;
                    text-align: center;
                }
            }
            .cosmetic-procedures-cont {
                margin-top: 20px;
                padding: 0 20px;

                .cosmetic-procedures-item {
                    margin-top: 20px;
                    width: 33.3%;
                    height: 105px;

                    img {
                        width: 80px;
                        height: 80px;
                        opacity: 0.8;
                    }

                    div {
                        font-size: 14px;
                    }
                }
            }
        }
        .download-message-cont {
            padding: 80px 20px;
            flex-direction: column;
            .qrcode-cont {
                margin-left: 0;
                text-align: center;
            }
        }
    }
}
</style>
